/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/Slutstation/"

const Slutstation: CommunityData = {
  code: "slutstation",
  inviteCode: "slutstation",
  name: "Slutstation",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/slu-022`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#ffffff",
      counterColor: "#ffffff",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[200px] h-[21px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[150px] h-[16px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#000000",
      asideStyles: "!p-0 !gap-0 !bg-[#000000] border-r border-[#333333]",
      contentBg: "#000000",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.jpg`,
      mainFont: "font-['MontserratRegular']",
      primaryButton:
        "bg-[#ffffff] border-2 border-[#ffffff] px-[18px] py-[18px] !text-[#222222] font-['AntonRegular'] !text-[20px] uppercase text-left",
    },
    navigation: {
      iconsColor: "#ffffff",
      sideBarSeparator: "border-r-[1px] border-[#333333]",
      separator: "#333333",
      item: "font-['AntonRegular'] text-[16px] text-[#ffffff] text-opacity-50 uppercase text-center border-b border-[#333333] !pl-0 !py-3 gap-x-[10px]",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8 !border !border-[#333333]",
      titles: "text-[#ffffff] font-['AntonRegular'] text-[28px] uppercase text-left leading-[120%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#bdbdbd] font-['MontserratRegular'] text-[14px] text-left",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#333333]",
        sectionTitle:
          "text-[#ffffff] font-['AntonRegular'] text-[28px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title:
            "text-[#ffffff] font-['AntonRegular'] text-[20px] uppercase text-left leading-[120%]",
          subtitle: "text-[#bdbdbd] font-['MontserratRegular'] text-[14px] text-left mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 border-b border-[#333333]",
        sectionTitle:
          "text-[#ffffff] font-['AntonRegular'] text-[28px] uppercase text-left leading-[120%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#000000]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#ffffff] font-['MontserratSemiBold'] text-[16px] text-left",
          subtitle: "text-[#bdbdbd] font-['MontserratRegular'] text-[12px] text-left mt-1",
          location: "text-[#bdbdbd] font-['MontserratRegular'] text-[12px] text-left mt-1",
          date: "text-[#bdbdbd] font-['MontserratRegular'] text-[12px] text-left mt-1",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title:
          "text-[#ffffff] font-['AntonRegular'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['MontserratRegular'] text-[16px] text-left",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#ffffff] font-['AntonRegular'] text-[28px] uppercase text-left leading-[120%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] !pb-8 !border !border-[#333333]",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#333333]",
        media: "aspect-video !h-[180px] w-full object-cover sm:mb-4",
        title:
          "text-[#ffffff] font-['AntonRegular'] text-[28px] uppercase text-left leading-[120%] mb-2",
        subtitle: "text-[#bdbdbd] font-['MontserratRegular'] text-[14px] text-left mb-4",
        button:
          "bg-[#ffffff] border-2 border-[#ffffff] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#222222] font-['AntonRegular'] !text-[20px] uppercase text-left",
        questions: "text-[14px] text-left text-[#bdbdbd]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header:
          "text-[#ffffff] font-['AntonRegular'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['MontserratRegular'] text-[14px] text-left mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header:
          "text-[#ffffff] font-['AntonRegular'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['MontserratRegular'] text-[14px] text-left mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#333333] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header:
          "text-[#ffffff] font-['AntonRegular'] text-[24px] uppercase text-left leading-[120%]",
        text: "text-[#ffffff] font-['MontserratRegular'] text-[14px] text-left",
      },
      tickets: {
        header:
          "text-[#ffffff] font-['AntonRegular'] text-[28px] uppercase text-left leading-[120%] px-4 sm:px-8 pt-4 sm:pt-8",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between gap-4 leading-auto !bg-[#000000] border-b border-[#333333] py-2 mb-4",
          media: "!hidden",
          name: "text-[#ffffff] font-['MontserratSemiBold'] text-[16px] text-left",
          description:
            "text-[#bdbdbd] font-['MontserratRegular'] text-[14px] text-left flex flex-row gap-1",
          price: "text-[#bdbdbd] font-['MontserratSemiBold'] text-[16px] text-left",
          quantity:
            "text-[#ffffff] font-['AntonRegular'] text-[14px] uppercase text-left leading-[100%]",
          status: "text-[#bdbdbd] font-['MontserratSemiBold'] text-[16px] text-left",
          counterContainer:
            "bg-[#000000] border-2 border-[#ffffff] px-[16px] py-[8px] gap-x-[16px] !w-fit",
          button:
            "bg-[#000000] border-2 border-[#ffffff] px-[16px] py-[8px] text-[#ffffff] font-['AntonRegular'] text-[14px] uppercase text-left leading-[100%] !w-fit",
          plusMinusColor: "#ffffff",
        },
      },
    },
  },
}

export default Slutstation
